import { render, staticRenderFns } from "./DebrisFormulaConfig.vue?vue&type=template&id=004a43ea&scoped=true&"
import script from "./DebrisFormulaConfig.vue?vue&type=script&lang=js&"
export * from "./DebrisFormulaConfig.vue?vue&type=script&lang=js&"
import style0 from "./DebrisFormulaConfig.vue?vue&type=style&index=0&id=004a43ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004a43ea",
  null
  
)

export default component.exports